import React, { Component } from "react";
import { s360ConfigService } from "../Services/S360Config";
import "./ConversationStyleSheet.css";
import Message from "./MessageBoxTypes/Message";
import { CircularProgress } from "@material-ui/core";
import ChatLoader from "../../utils/LoaderComponent/ChatLoader";

class Conversation extends Component {
  constructor(props) {
    super(props);
    this.conversationRef = React.createRef();
  }

  scrolltoStartingMessage = () => {
    this.conversationRef.current.scrollTop =
      this.conversationRef.current.scrollHeight;
  };

  scrollToLatestMessage = () => {
    this.conversationRef.current.scrollTop =
      this.conversationRef.current.scrollHeight;
  };

  scrollToLastPosition = () => {
    //initially when chat loads scroll to latest message (down) --> Math.max
    //initially when chat loads scroll to starting message (down) --> Math.min
    if (this.props.messagesLength <= 2) {
      this.conversationRef.current.scrollTop = Math.min(
        this.conversationRef.current.scrollHeight - this.lastScrollHeight,
        0
      );
    } else {
      this.conversationRef.current.scrollTop = Math.max(
        this.conversationRef.current.scrollHeight - this.lastScrollHeight,
        0
      );
    }
  };

  lastScrollHeight = 0;

  onConversationScroll = () => {
    let scrollContainer = this.conversationRef.current;
    this.lastScrollHeight = scrollContainer.scrollHeight;
    let isTop = scrollContainer.scrollTop === 0;
    if (
      isTop &&
      this?.props?.onScrollToConversationTop() !== undefined &&
      this?.props?.onScrollToConversationTop() !== null &&
      typeof this.props?.onScrollToConversationTop() === "function"
    ) {
      this?.props?.onScrollToConversationTop();
    }
  };
  render() {
    const messages = this.props.messages || [];
    const isFetchingMessages = this.props.isFetchingMessages || false;
    const isFetchingMessagesBelow = this.props.isFetchingMessagesBelow || false;
    const isLoaderEnabled = s360ConfigService.config.enableLoader || false;
    console.log(this.props.isFetchingMessagesBelow, "message loader");
    const isFullScreen = localStorage.getItem("openInFullScreen");

    return (
      <div
        ref={this.conversationRef}
        // onScroll={this.onConversationScroll}
        className={isFullScreen ? "s360-conversation-fs" : "s360-conversation"}
        role="log"
        aria-live="polite"
        aria-relevant="additions"
        aria-label="Chat messages"
        style={ !!s360ConfigService.config.designDetails?.hideCardBoxShadow ? { boxShadow: "none" } : {} }
      >
        {isFetchingMessages && (
          <div
            className="s360-message-cotainer-activity-indicator"
            style={{
              color: this.props.config.designDetails.headerColor || "lightgray",
            }}
          >
            <CircularProgress color="inherit" size={20} />
            <span style={{ marginLeft: "2rem" }}> Loading...</span>
          </div>
        )}
        {messages.map((message) => (
          <Message
            switchBot={this.props?.switchBot}
            //TODO PASS LOADER FROM PROPS TO MESSAGE
            scrollToLatest={() => this.scrollToLatestMessage()}
            {...this.props}
            message={message}
            key={message.id}
            startNewConversation={this.props.startNewConversation}
            handleCustomerRetryMsg={this.props.handleCustomerRetryMsg}
          />
        ))}

        {!this.props.disableLoader &&
          isLoaderEnabled &&
          isFetchingMessagesBelow && (
            <div
              className="s360-message-cotainer-activity-indicator"
              style={{
                color: this.props.config.designDetails.headerColor || "lightgray",
                ...(this.props.config.designDetails.customActivityIndicator || {})
              }}
            >
              <ChatLoader />
            </div>
          )}
      </div>
    );
  }
}

export default Conversation;
